export const LOGIN_ERRORS = {
  NON_PRO: `Not a Pro Carrier or a Pro combo Account`,
  INVALID: 'Invalid credentials provided',
};
